import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//rxjs
import { Observable, BehaviorSubject } from 'rxjs';
import { Cities, CitiesVenue } from '../models/cities';
import { IRecruiterUnitLocations, IRecruiterUnitSkills, SelectionMenu } from '../models/requestUnitModel';
import { CreateEvent, RequisitionCandidate, CreateEventUI, InterviewMode } from '../models/createEvent';
import { EventDetails, SkillDetail } from 'src/app/modules/recruiterpersona/models/editEvent';
import { Panelist, PanelistCheck, AddPanelist, DeletePanelistResp } from '../models/panelist';
import { CandidatesByEvent } from 'src/app/modules/recruiterpersona/models/candidates';
import { environment } from 'src/environments/environment.prod';
import { ReqCandidates } from '../models/reqCandidates';
import { IndentDetail, IndentErrLog } from 'src/app/shared/models/IndentDetail';
import { assetUrl } from 'src/single-spa/asset-url';
import { InviteCountModel, InviteTemplate } from '../models/EventConntroller';
import { EventAsyncInput, EventAsyncOutput, ReqAsyncOutput } from '../models/EventAsyncModel';
import { EnvService } from 'src/app/env.service';

declare let _AzureStorage: any;

@Injectable({
  providedIn: 'root',
})
export class RecruiterService {
  recruiterUrl: string = environment.recruiterUrl;
  recruiterUrl2: string = environment.recruiterUrl2;
  recruiterGenUrl: string = environment.recruiterGenUrl;
  recruiterPanelistUrl: string = environment.recruiterPanelistUrl;
  recruiterDashboardUrl: string = environment.recruiterdashboardUrl;
  activityUrl: string = environment.activityUrl;
  camsUrl: string = environment.camsUrl;
  readonly offerWfUrl: string = environment.offerWF;

  private eventId$ = new BehaviorSubject([]);
  private skillObj$ = new BehaviorSubject<SkillDetail>({} as any);
  private cityObj$ = new BehaviorSubject([]);
  private eventDetailsObj$ = new BehaviorSubject([]);
  private selectedEventFlagType$ = new BehaviorSubject([]);
  private skillDetailsObj: any; // new BehaviorSubject<any>([] as any);

  private eventIdController: any; // new BehaviorSubject([]);
  private unitIdController: any; // new BehaviorSubject([]);
  private skillUnitNavigation: any; //new BehaviorSubject([]);

  id = localStorage.getItem('fresherCompHiringTypeId');
  userRoleCode = localStorage.getItem('roleCode');
  flagHM = localStorage.getItem('enableNewFlow');
  private editEventObj$ = new BehaviorSubject<CreateEventUI>({} as any);
  private editCurrentServiceLine$ = new BehaviorSubject<string>({} as any);
  constructor(
    private http: HttpClient,
    private envService: EnvService,
  ) {}

  readonly get_cities = `${this.recruiterUrl}Events/getcityDetails`;
  readonly get_units = `${this.recruiterGenUrl}getGenModelStructure/Requisition/` + this.id;
  readonly put_event_requisition_mapping = `${this.recruiterUrl2}v1/events/eventrequisitionmapping`;
  readonly put_event_delete_candidate = `${this.recruiterUrl2}v1/events/deleteCandidate`;
  readonly post_create_event = `${this.recruiterUrl}v1/admin/createEvent`;
  readonly get_event_details_dashboard = `${this.recruiterUrl}v1/admin/getEventDetails`;
  readonly get_event_view_details = `${this.recruiterUrl}v1/events/viewEventDetails`;

  readonly get_skill_details = `${this.recruiterGenUrl}getSkillDetails`;
  readonly delete_event_delete = `${this.recruiterUrl}v1/admin/deleteEvent`;
  readonly delete_event_unit = `${this.recruiterUrl}v1/admin/deleteEventByUnit`;
  readonly put_edit_event = `${this.recruiterUrl}v1/admin/editEventDetails`;
  readonly get_requisition_candidate = `${this.recruiterUrl}v1/admin/getRequisitionandCandidates`;
  readonly save_requisition_candidates = `${this.recruiterUrl}v1/admin/saveEventCandidates`;
  readonly get_panelist_list = `${this.recruiterUrl}v1/admin/getPanelist`;
  readonly get_panelist_check_data = `${this.recruiterUrl}`;
  readonly post_add_panelist = `${this.recruiterUrl}v1/admin/addEventPanelist`;
  readonly get_candidates_by_event_id = `${this.recruiterUrl}v1/admin/getEventCandidateDetails`;
  readonly get_move_candidate = `${this.recruiterUrl}v1/RecruiterCandidate/moveCandidatematching/`;
  readonly get_city_venue = `${this.activityUrl}activity/getVenues?companyHiringTypeId=` + this.id;
  readonly get_interview_mode = `${this.recruiterUrl}v1/admin/getModeOfInterview?companyHiringTypeId=` + this.id;
  readonly delete_candidate_by_event =
    'https://intaptest.infosysapps.com/infosys/intapeventreq/v1/events/deleteCandidate';

  readonly get_indent_details = `${this.offerWfUrl}v1/indent/getIndentDetails?`;
  readonly post_indent_block = `${this.offerWfUrl}v1/indent/bulkIndentBlock?`;
  readonly bulk_panelist = `${this.recruiterUrl}panelist/savePanelist/`;

  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };

  getIndentDetails(date, location): Observable<IndentDetail[]> {
    return this.http.get<IndentDetail[]>(this.get_indent_details + 'doj=' + date + '&cityId=' + location);
  }

  postIndentBlock(date, location, file): Observable<IndentErrLog[]> {
    //console.log("Serv",file);
    const requestOptions: object = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };
    return this.http.post<IndentErrLog[]>(
      this.post_indent_block + 'cityId=' + location + '&doj=' + date,
      file,
      requestOptions,
    );
  }

  // to get skills elastic search
  getSkillDetails(skillKeyword) {
    return this.http.get(` ${this.get_skill_details}/${this.id}/${skillKeyword}`);
  }

  getInterviewMode(): Observable<InterviewMode[]> {
    return this.http.get<InterviewMode[]>(`${this.get_interview_mode}`);
  }

  moveCandidate(eventUnitId, candidateId): Observable<any> {
    const _requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.http.get<string>(
      this.get_move_candidate + '?eventUnitId=' + eventUnitId + '&candidateId=' + candidateId,
      _requestOptions,
    );
  }

  deleteCandidateByEvent(eventId, candidateIds) {
    const obj = { candidateIds: candidateIds, eventId: eventId };
    console.log('DELETE OBJ', obj);

    //return of({status:"success",message:"Added"});
    return this.http.post<any>(this.delete_candidate_by_event, obj);
  }

  // to get city from venue table
  getCitiesVenue(): Observable<CitiesVenue[]> {
    return this.http.get<CitiesVenue[]>(`${this.get_city_venue}`);
  }
  // to get cities list elastic search
  getCities(initial: string): Observable<any> {
    console.log('service', `${this.get_cities}/${initial}`);
    // return this.http.get<Cities>('')
    return this.http.get<Cities>(`${this.get_cities}/${initial}`);
  }

  //Get logs data for requition async copy service
  reqAsyncLogs(body) {
    return this.http.post<ReqAsyncOutput[]>(this.recruiterGenUrl + 'getCopyRequisition', body);
  }

  commentsDownload(seqId) {
    return this.http.get<any>(this.recruiterGenUrl + 'getCopyRequisitionLogs/' + seqId);
  }

  // to get event details in dashboard
  getEventDetailsDashboard(body): Observable<object[]> {
    return this.http.post<any>(`${this.get_event_details_dashboard}`, body);
    // return this.http.get<Object[]>('assets/json/getEvent.json');
  }

  // get view event details

  getViewEventDetails(eventID, eventFlag): Observable<EventDetails> {
    return this.http.get<EventDetails>(
      `${this.get_event_view_details}` + '?eventId=' + eventID + '&copiedEvent=' + eventFlag,
    );
  }

  // put requistion mapping
  putRequistionMapping(eventMapping) {
    // console.log('sat',eventMapping);

    return this.http.post(`${this.put_event_requisition_mapping}`, eventMapping);
  }

  // save dreaft mode ; after clicking proceed
  saveEventDetails(proceedCreateEventObj: CreateEvent): Observable<string> {
    const _requestOptions: object = {
      responseType: 'text',
    };
    console.log('mon', proceedCreateEventObj);

    return this.http.post<string>(this.post_create_event, proceedCreateEventObj, _requestOptions);
  }

  editEventDetails(proceedCreateEventObj: CreateEvent): Observable<any> {
    const _requestOptions: object = {
      responseType: 'text',
    };
    console.log('mon', proceedCreateEventObj);
    console.log('service', this.put_edit_event);
    // return this.http.post<string>(this.put_edit_event, proceedCreateEventObj, requestOptions);
    return this.http.post<any>(this.put_edit_event, proceedCreateEventObj, _requestOptions);
  }

  deleteEvent(eventID: number): Observable<any> {
    const _requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    return this.http.get<any>(this.delete_event_delete + '?eventId=' + eventID, _requestOptions);
  }

  deleteEventUnit(eventId, eventUnitId, unitCode?): Observable<any> {
    const _requestOptions: object = {
      responseType: 'text',
      headers: new HttpHeaders().set('Content-Type', 'application/json'),
    };
    console.log('isssues', eventId, eventUnitId, unitCode);
    console.log(
      'issues',
      (this.delete_event_unit + '?eventId=' + eventId + '&eventUnitId=' + eventUnitId, _requestOptions),
    );

    if (unitCode) {
      return this.http.get<string>(
        this.delete_event_unit + '?eventId=' + eventId + '&eventUnitId=' + eventUnitId + '&unitCode=' + unitCode,
        _requestOptions,
      );
    } else {
      return this.http.get<string>(
        this.delete_event_unit + '?eventId=' + eventId + '&eventUnitId=' + eventUnitId,
        _requestOptions,
      );
    }
  }

  // setting and getting event id
  setEventId(val) {
    this.eventId$.next(val);
    console.log(this.eventId$);
  }

  getEventId() {
    return this.eventId$.asObservable();
  }

  set_selectedEventFlagType(val) {
    this.selectedEventFlagType$.next(val);
    console.log(this.selectedEventFlagType$);
  }

  get_selectedEventFlagType() {
    return this.selectedEventFlagType$.asObservable();
  }

  setSkillObj(object) {
    this.skillObj$.next(object);
    console.log(this.skillObj$);
  }
  getSkillObj() {
    return this.skillObj$.asObservable();
  }

  setEditEventObj(object) {
    this.editEventObj$.next(object);
  }

  getEditEventObj() {
    return this.editEventObj$.asObservable();
  }

  setEditCurrentServiceLine(object) {
    this.editCurrentServiceLine$.next(object);
  }

  getEditCurrentServiceLine() {
    return this.editCurrentServiceLine$.asObservable();
  }

  setCity(value) {
    this.cityObj$.next(value);
    console.log(this.cityObj$);
  }

  getCity() {
    return this.cityObj$.asObservable();
  }

  seteventDetailsObj(eventDetailsObj) {
    this.eventDetailsObj$.next(eventDetailsObj);
  }

  geteventDetailsObj() {
    return this.eventDetailsObj$.asObservable();
  }

  // to get units manan
  getUnits(_unitByIdandName): Observable<any> {
    console.log('!!!GEN model service for units called');

    return this.http.get<any>(`${this.get_units}`);
  }

  putEditEventDetail(editEventObj) {
    return this.http.post(`${this.put_edit_event}`, editEventObj);
  }

  getRequsitionAndCandidate(eventUnitId): Observable<ReqCandidates[]> {
    //return this.http.get<ReqCandidates[]>('assets/json/reqCand.json');
    return this.http.get<ReqCandidates[]>(this.get_requisition_candidate + '?eventUnitId=' + eventUnitId);
  }

  saveRequisitionAndCandidate(reqCandidateObj: RequisitionCandidate): Observable<any> {
    const _requestOptions: object = {
      responseType: 'text',
    };
    return this.http.post<any>(this.save_requisition_candidates, reqCandidateObj, _requestOptions);
  }
  getPanelistList(eventId: number, unitId: number): Observable<Panelist[]> {
    return this.http.get<Panelist[]>(
      this.get_panelist_list + '?eventId=' + eventId + '&companyHiringTypeId=' + this.id + '&unitId=' + unitId,
      this.options,
    );
  }

  getPanelistCheckData(empNo: number): Observable<PanelistCheck> {
    console.log('recruiter url', this.put_edit_event);
    console.log('recruiter url 2', this.put_event_delete_candidate);
    console.log('gen url', this.get_units);
    const body = { empNo: empNo };
    return this.http.post<PanelistCheck>(
      this.get_panelist_check_data + 'panelist / checkPanelistEligility',
      body,
      this.options,
    );
  }

  insertPanelistDetails(panelistObj: AddPanelist): Observable<any> {
    return this.http.post<any>(this.post_add_panelist, panelistObj);
  }

  // to get candidates by event id:
  getCandidatesByEvent(eventId): Observable<CandidatesByEvent[]> {
    const _paramToPass = { eventId: eventId };
    return this.http.get<CandidatesByEvent[]>(
      this.get_candidates_by_event_id + '?eventId=' + eventId + '&companyHiringTypeId=' + this.id,
    );
  }
  getRecruiterUnit(unitList): Observable<any> {
    return this.http.post<any>(this.recruiterDashboardUrl + 'getUnitList', unitList);
  }
  getRecruiterUnitSkills(): Observable<IRecruiterUnitSkills[]> {
    return this.http.get<IRecruiterUnitSkills[]>('assets/json/unitSkills.json');
  }
  getRecruiterUnitList(
    unit: string,
    group: string,
    tab: string,
    companyHiringTypeId,
  ): Observable<IRecruiterUnitSkills[]> {
    if (this.userRoleCode == 'HiringManager' && this.flagHM == 'Y') {
      const data = {
        unitCode: unit,
        type: group,
        requestType: tab,
        companyHiringTypeId: companyHiringTypeId,
        role: 'HM',
      };
      return this.http.post<IRecruiterUnitSkills[]>(this.recruiterDashboardUrl + 'getDashBoardDetailsByRole', data);
    } else {
      return this.http.get<IRecruiterUnitSkills[]>(
        this.recruiterDashboardUrl + 'getListByUnit/' + unit + '/' + group + '/' + tab + '/' + companyHiringTypeId,
      );
    }
    //  return this.http.get<IRecruiterUnitSkills[]>('assets/json/unitSkills.json');
    // ENG/skill');
  }
  getRecruiterUnitLocations(): Observable<IRecruiterUnitLocations[]> {
    return this.http.get<IRecruiterUnitLocations[]>('assets/json/recruiterUnitLocations.json');
  }

  getdata() {
    return this.http.get('assets/jsons/basicdetails.json');
  }

  getTableData(employeeId, companyHiringTypeId, flag): Observable<SelectionMenu> {
    const body = { employeeId: employeeId, companyHiringTypeId: companyHiringTypeId, flag: flag };
    if (this.userRoleCode == 'HiringManager') {
      body['roleCode'] = this.userRoleCode;
    }
    return this.http.post<SelectionMenu>(
      this.recruiterDashboardUrl + 'recruiterdashboard/getRecruiterDetailsById',
      body,
    );
  }

  getUpdatedTableData(body): Observable<SelectionMenu> {
    return this.http.post<SelectionMenu>(this.recruiterDashboardUrl + 'recruiterdashboard/saverecruiter', body);
  }
  getRequestTableData(id, groupby, unit, tab, companyHiringTypeId): Observable<any> {
    if (companyHiringTypeId == 4 && this.userRoleCode == 'HiringManager') {
      return this.http.get(
        this.recruiterDashboardUrl +
          'getListBySkillLocation/' +
          id +
          '/' +
          groupby +
          '/' +
          unit +
          '/' +
          tab +
          '/' +
          companyHiringTypeId +
          '/HM',
      );
    } else {
      const supportKey = 'N';
      return this.http.get(
        this.recruiterDashboardUrl +
          'getListBySkillLocation/' +
          id +
          '/' +
          groupby +
          '/' +
          unit +
          '/' +
          tab +
          '/' +
          companyHiringTypeId +
          '/' +
          supportKey,
      );
    }
  }

  getUnitIdList(unitsIdBody): Observable<any> {
    return this.http.post<any>(this.camsUrl + 'Contexts', unitsIdBody);
  }

  reqSearch(searchKey, companyHiringTypeId): Observable<any> {
    const supportKey = this.id == '4' ? 'Y' : 'N';
    return this.http.get<any>(
      this.recruiterDashboardUrl + 'getDashboardDetails/' + searchKey + '/' + companyHiringTypeId + '/' + supportKey,
    );
  }

  requisitionDelete(body): Observable<any> {
    const textOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8'),
      responseType: 'text' as 'json',
    };
    return this.http.post<any>(this.recruiterGenUrl + 'v1/requisition/deleteRequisition', body, textOptions);
  }

  getTotalCandidateCount(eventId, unitId, skillId, eventUnitId): Observable<any> {
    if (skillId == null) {
      return this.http.get<any>(
        this.recruiterUrl +
          'v1/UniSkillToBeScheduleCount/totalCountOfCandidateForEvent?eventId=' +
          eventId +
          '&unitId=' +
          unitId,
      );
    } else {
      return this.http.get<any>(
        this.recruiterUrl +
          'v1/UniSkillToBeScheduleCount/totalCountOfCandidateForEvent?eventId=' +
          eventId +
          '&unitId=' +
          unitId +
          '&eventUnitId=' +
          eventUnitId,
      );
    }
  }

  getToBeScheduled(eventId, unitId, skillId, eventUnitId): Observable<any> {
    if (skillId == null) {
      return this.http.get<any>(
        this.recruiterUrl + 'v1/UniSkillToBeScheduleCount/toBeScheduleCount?eventId=' + eventId + '&unitId=' + unitId,
      );
    } else {
      return this.http.get<any>(
        this.recruiterUrl +
          'v1/UniSkillToBeScheduleCount/toBeScheduleCount?eventId=' +
          eventId +
          '&unitId=' +
          unitId +
          '&eventUnitId=' +
          eventUnitId,
      );
    }
  }
  getFilteredCount(body): Observable<any> {
    console.log('filtered count', body);
    return this.http.post<any>(this.recruiterUrl + 'getFilterCriteriaCount', body);
  }
  getEventConfirmed(eventId, _unitId): Observable<any> {
    return this.http.get<any>(
      this.recruiterUrl + 'v1/UniSkillToBeScheduleCount/totalEventConfirmation?eventId=' + eventId,
    );
  }
  getViewSkillTable(): Observable<any> {
    return this.http.get(assetUrl('./json/viewskill.json'));
  }
  addBulkPanelist(eventId, unitId, file): Observable<any> {
    //console.log("Serv",file);
    const _requestOptions: object = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };
    return this.http.post<any>(this.bulk_panelist + eventId + '?unitId=' + unitId, file, _requestOptions);
  }
  readonly delete_panelist = `${this.recruiterUrl}panelist/deletePanelist`;
  deletePanelist(deleteObj): Observable<DeletePanelistResp> {
    const _requestOptions: object = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    };
    return this.http.post<DeletePanelistResp>(this.delete_panelist, deleteObj, _requestOptions);
  }
  // Invite template STARTS
  get_inviteTemplate_JSON = 'assets/json/inviteTemplates.json';
  getInviteTemplate(id) {
    return this.http.get<InviteTemplate[]>(this.recruiterUrl + 'v1/event/getTemplates?companyHiringTypeId=' + id);
  }

  get_mailInviteCount = `${this.recruiterUrl}v1/event/mailsCountForEvent?eventId=`;
  getMailCount(eventId, buttonName) {
    return this.http.get<InviteCountModel>(this.get_mailInviteCount + eventId + '&buttonName=' + buttonName);
  }

  setSkillDetailsObj(object) {
    this.skillDetailsObj = object;
    console.log(this.skillDetailsObj);
  }
  getSkillDetailsObj() {
    return this.skillDetailsObj;
  }
  EC_tabIndex = 0;
  setEventControllerTabIndex(index) {
    this.EC_tabIndex = index;
  }
  getEventControllerTabIndex() {
    return this.EC_tabIndex;
  }
  //Event Controller Tab Index ENDS
  setEventIdController(val) {
    // this.eventIdController$.next(val);
    // console.log(this.eventIdController$);
    this.eventIdController = val;
  }

  getEventIdController() {
    // return this.eventIdController$.asObservable();
    return this.eventIdController;
  }
  setUnitIdController(val) {
    // this.unitIdController$.next(val);
    // console.log(this.unitIdController$);
    this.unitIdController = val;
  }

  getUnitIdController() {
    // return this.unitIdController$.asObservable();
    return this.unitIdController;
  }
  setSkillUnit(val) {
    // this.skillUnitNavigation$.next(val);
    // console.log(this.skillUnitNavigation$);
    this.skillUnitNavigation = val;
  }

  getSkillUnit() {
    // return this.skillUnitNavigation$.asObservable();
    return this.skillUnitNavigation;
  }

  //Save ShortList data STARTS
  put_saveShortList = this.recruiterUrl + 'saveShortListCriteriaEvent';
  saveShortList(dataObj) {
    return this.http.post<any>(this.put_saveShortList, dataObj);
  }
  put_saveEmptyShortList = this.recruiterUrl + 'deleteShortListCriteriaEvent';
  saveEmptyShortList(dataObj) {
    return this.http.post<any>(this.put_saveEmptyShortList, dataObj);
  }
  get_sourceTypeList = this.recruiterUrl + 'v1/sourceListByCandidates';
  getSourceList(dataObj) {
    return this.http.post<any>(this.get_sourceTypeList, dataObj);
  }
  get_shortlistData_JSON = 'assets/json/shortlistData.json';
  get_shortlistData = this.recruiterUrl + 'getShortListCriteriaEvent';
  getShortlistData(dataObj) {
    //return this.http.get<any>(this.get_shortlistData_JSON);
    return this.http.post<any>(this.get_shortlistData, dataObj);
  }
  //Save ShortList data ENDS
  //Schedule Upload STARTS
  scheduleUpload(eventId) {
    return this.http.get(this.recruiterUrl + 'v1/events/getCandidatesForEvent/' + eventId);
  }
  //Schedule Upload ENDS
  sendInvite(body): Observable<any> {
    console.log('send mail serv', body);
    return this.http.post<any>(this.recruiterUrl + 'v1/event/mailInvite', body);
  }

  async asyncEventTracking(eventId) {
    return await this.http.post<any>(this.recruiterUrl + 'v1/event/eventTracking', eventId).toPromise();
  }

  async asyncEventCheck(eventObj: EventAsyncInput) {
    return await this.http
      .post<EventAsyncOutput[]>(this.recruiterUrl + 'v1/event/eventAsyncCheck', eventObj)
      .toPromise();
  }

  getBtnNames() {
    return this.http.get<any[]>('assets/cdn/json/buttonNames.json');
  }
  async uploadCandidatesManually(eventId, companyHiringTypeId, buttonName, file, flag) {
    const _requestOptions: object = {
      responseType: 'text',
      'Content-Type': 'multipart/form-data',
    };
    let fileBody: any;
    if (flag != 'R') {
      fileBody = {
        eventId: eventId,
        companyHiringTypeId: companyHiringTypeId,
        buttonName: buttonName,
        file: file,
      };
    } else {
      fileBody = {
        eventId: eventId,
        companyHiringTypeId: companyHiringTypeId,
        buttonName: buttonName,
        rejectionFlag: 'R',
        file: file,
      };
    }
    console.log(file);
    return await this.http.post<any>(this.recruiterUrl + 'v1/events/uploadCandidatesManually', fileBody).toPromise();
  }
  uploadPCICandidates(eventId, companyHiringTypeId, buttonName, file) {
    const _requestOptions: object = {
      responseType: 'text',
      'Content-Type': 'multipart/form-data',
    };
    const fileBody = {
      eventId: Number(eventId),
      companyHiringTypeId: companyHiringTypeId,
      buttonName: buttonName,
      file: file,
    };
    return this.http.post<any>(this.recruiterUrl + 'v1/events/uploadPCIcandidates', fileBody);
  }
  excelUploadManually(obj, file) {
    const _requestOptions: object = {
      responseType: 'text',
      'Content-Type': 'multipart/form-data',
    };
    let fileBody;
    if (obj.taxonomyUnitId) {
      fileBody = {
        taxonomyUnitId: obj.taxonomyUnitId,
        eventId: obj.eventId,
        eventUnitId: obj.eventUnitId,
        buttonName: obj.buttonName,
        file: file,
      };
    } else {
      fileBody = {
        skillIds: obj.skillIds,
        eventId: obj.eventId,
        eventUnitId: obj.eventUnitId,
        buttonName: obj.buttonName,
        file: file,
      };
    }
    return this.http.post<any>(this.recruiterUrl + 'v1/events/saveEventCandidateManually', fileBody);
  }
  downloadPCI(eventId) {
    return this.http.get<any>(this.recruiterUrl + 'v1/admin/getCandidateDetailsForPCI?eventId=' + eventId);
  }

  getEventUnits(): Observable<any> {
    return this.http.get<any>(this.recruiterUrl + 'v1/events/unitList');
  }

  private copyEventId = null;

  setCopyEventId(id) {
    this.copyEventId = id;
  }

  getCopyEventId() {
    return this.copyEventId;
  }

  copyEventSkills(eventId, unitDetailsMap): Observable<any> {
    const textOptions = {
      headers: new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8'),
      responseType: 'text' as 'json',
    };
    return this.http.post<any>(
      this.recruiterUrl + 'v1/events/copyEvent?eventId=' + eventId,
      unitDetailsMap,
      textOptions,
    );
  }

  failedCasesDownload(serialNum) {
    return this.http.get<any>(this.recruiterUrl + 'v1/events/getFailedCandidates?serialNum=' + serialNum);
  }

  copyMultipleRequisitions(reqIdListObj): Observable<any> {
    return this.http.post<any>(this.recruiterGenUrl + 'copyRequisition', reqIdListObj);
  }

  getStartTimeSlots(): Observable<any> {
    return this.http.get<any>(this.recruiterUrl + 'v1/admin/getSlotDetails?companyHiringTypeId=' + this.id);
  }

  getSubConData(subconReq): Observable<any> {
    return this.http.post<any>(this.recruiterGenUrl + 'getS2HS2RLdetails', subconReq);
  }

  restrictSpclChar(e) {
    const key = document.all ? e.keyCode : e.which;
    return (
      (key > 64 && key < 91) ||
      (key > 96 && key < 123) ||
      key == 8 ||
      key == 32 ||
      (key >= 48 && key <= 57) ||
      key == 45 ||
      key == 46 ||
      key == 44
    );
  }

  rstrctPasteSpclChar(e) {
    if (e && e.clipboardData && e.clipboardData.getData('text')) {
      if (!e.clipboardData.getData('text').match('^[a-zA-Z0-9 .,-]*$')) {
        return false;
      }
    }
  }
  overallStatus(payload): Observable<any> {
    return this.http.post<any>(this.offerWfUrl + 'v1/dashboard/getRecruiterDashboardCandidates', payload);
  }
  actionPending(payload): Observable<any> {
    return this.http.post<any>(this.offerWfUrl + 'v1/dashboard/getRecruiterDashboardCandidates', payload);
  }
}
